export function formatPhoneNumber(phoneNumber: string) {
  const validPhoneNumberPattern = /^[\d\s()+-]+$/;
  phoneNumber = phoneNumber.trim();
  if (!validPhoneNumberPattern.test(phoneNumber)) {
    return phoneNumber;
  }
  const firstChar = phoneNumber?.charAt(0);
  if (firstChar !== '+') {
    if (firstChar === '0') {
      phoneNumber = '+49' + phoneNumber.slice(1);
    } else {
      phoneNumber = '+49' + phoneNumber;
    }
  }
  phoneNumber = phoneNumber.replace(/^(\+\d{2})(\d+)$/, '$1 $2');
  return phoneNumber;
}
